module.exports = __webpack_public_path__ + "img/epr-article-top-img@2x.88f2c0bd.jpeg";